var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.25 20.1667H5.5C3.98122 20.1667 2.75 18.9355 2.75 17.4167V4.58337C2.75 3.06459 3.98122 1.83337 5.5 1.83337H19.25V16.5C18.7437 16.5 18.3333 16.9104 18.3333 17.4167C18.3333 17.923 18.7437 18.3334 19.25 18.3334V20.1667ZM16.5 17.4167C16.5 17.0953 16.5551 16.7868 16.6565 16.5H5.5C4.99374 16.5 4.58333 16.9104 4.58333 17.4167C4.58333 17.923 4.99374 18.3334 5.5 18.3334H16.6565C16.5551 18.0467 16.5 17.7381 16.5 17.4167ZM5.5 3.66671H17.4167V14.6667H5.5C5.17858 14.6667 4.87005 14.7218 4.58333 14.8232V4.58337C4.58333 4.07711 4.99374 3.66671 5.5 3.66671Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.566bbc79d2bc770394d47ab5004fe312.svg";
export { ForwardRef as ReactComponent };